module.exports = __webpack_public_path__ + "static/img/banner1.511a1325.png";